import {
	FACET_FILTERS,
	FETCH_DATA_ERROR,
	FETCH_DATA_PENDING,
	FETCH_FACETS_SUCCESS,
	FETCH_PAGINATION_SUCCESS,
	FETCH_TEASERS_SUCCESS,
	FILTER_BY_CATEGORY,
	FILTER_BY_LOCATION,
	FILTER_BY_PAGE,
	FILTER_BY_REGION,
	FILTER_BY_SUBJECT,
	FILTER_BY_VALUE,
	LOCATION_VALUE,
	QUERY_VALUE,
	PAGE_INTRO,
} from "../reducers";

import { initialState } from "./initialState";

export function teasersReducer(state = initialState, action) {
	switch (action.type) {
		/**
		 * DATA LOAD STATUS
		 */
		case FETCH_DATA_PENDING:
			return {
				...state,
				pending: true,
			};

		case FETCH_DATA_ERROR:
			return {
				...state,
				pending: false,
				error: action.error,
			};

		/**
		 * FETCH TEASERS
		 */
		case FETCH_TEASERS_SUCCESS:
			return {
				...state,
				pending: false,
				filteredTeasers: action.payload,
			};

		/**
		 * FETCH & PARSE FACETS
		 */
		case FETCH_FACETS_SUCCESS:
			let facets = action.payload;
			let regions = [];
			let categories = [];
			let subjects = [];

			// Regio's uit JSON halen
			Object.keys(facets[1].options).forEach(function (key, index) {
				regions.push({
					label: facets[1].options[key].label,
					count: facets[1].options[key].count,
				});
			});

			/**
			 * Categorieën en subcategorieën uit de JSON halen zodat ze een cijfer index krijgen ipv. key index
			 * Non-associative array
			 */
			Object.keys(facets[2].options).forEach(function (key, index) {
				if ("undefined" !== typeof facets[2].options[key].children) {
					let subcategories = [];
					Object.keys(facets[2].options[key].children).forEach(
						function (child, index) {
							subcategories.push({
								slug: facets[2].options[key].children[child]
									.slug,
								label: facets[2].options[key].children[child]
									.label,
								count: facets[2].options[key].children[child]
									.count,
								searchparam:
									facets[2].options[key].children[child]
										.searchparam,
							});
						}
					);
					categories.push({
						slug: facets[2].options[key].slug,
						label: facets[2].options[key].label,
						count: facets[2].options[key].count,
						children: subcategories,
					});
				} else {
					categories.push({
						slug: facets[2].options[key].slug,
						label: facets[2].options[key].label,
						count: facets[2].options[key].count,
					});
				}
			});

			Object.keys(facets[3].options).forEach((key) => {
				subjects.push({
					slug: facets[3].options[key].slug,
					label: facets[3].options[key].label,
					count: facets[3].options[key].count
				})
			})

			return {
				...state,
				pending: false,
				regions: regions,
				categories: categories,
				allCategories: facets[2],
				subjects: subjects,
			};

		/**
		 * FETCH PAGINATION
		 */
		case FETCH_PAGINATION_SUCCESS:
			return {
				...state,
				totalResults: action.payload.totalResults,
				currentPage: action.payload.currentPage,
				totalPages: action.payload.totalPages,
			};

		/**
		 * FILTER BY
		 */
		case FILTER_BY_VALUE:
			return {
				...state,
				activeQuery: action.payload,
				error: action.error,
			};

		case QUERY_VALUE:
			return {
				...state,
				queryValue: action.payload,
			};

		case FILTER_BY_CATEGORY:
			let activeCategories = action.payload;
			let allCategories = state.allCategories.options;

			let activeCategoriesObject = [];

			/**
			 * Check of de actieve locatie een topthema en/of thema bevat
			 */

			if (activeCategories.includes("|")) {
				let categoryList = activeCategories.split("|");
				activeCategoriesObject = {
					activeCategory: allCategories[categoryList[0]].slug,
					activeCategoryLabel: allCategories[categoryList[0]].label,
					activeSubcategory:
						allCategories[categoryList[0]].children[categoryList[1]]
							.slug,
					activeSubcategoryLabel:
						allCategories[categoryList[0]].children[categoryList[1]]
							.label,
				};
			} else if ("" !== activeCategories) {
				activeCategoriesObject = {
					activeCategory: allCategories[activeCategories].slug,
					activeCategoryLabel: allCategories[activeCategories].label,
				};
			} else {
				activeCategories = "";
			}

			return {
				...state,
				activeCategories: activeCategories,
				activeCategoriesObj: activeCategoriesObject,
				error: action.error,
			};

		case FILTER_BY_LOCATION:
			return {
				...state,
				activeLocation: action.payload,
				error: action.error,
			};

		case LOCATION_VALUE:
			return {
				...state,
				locationValue: action.payload,
			};

		case FILTER_BY_REGION:
			return {
				...state,
				activeRegions: action.payload,
				error: action.error,
			};

		case FILTER_BY_SUBJECT:
			return {
				...state,
				activeSubjects: action.payload,
				error: action.error,
			};

		case FACET_FILTERS:
			return {
				...state,
				facetFilters: action.payload,
				error: action.error,
			};

		case FILTER_BY_PAGE:
			return {
				...state,
				currentPage: action.payload,
				error: action.error,
			};

		case PAGE_INTRO:
			return {
				...state,
				pageIntro: action.payload,
				error: action.error,
			};

		default:
			return state;
	}
}
